import VisibilityIcon from "@mui/icons-material/Visibility";
import { Button, IconButton } from "@mui/material";
import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { adminButtonPrimarySx } from "../../../../../components/AdminDashboard/modalStyle";
import { ModalComponent } from "../../../../../ui-components/Modal";
import { parseDateLocale } from "../../../../../utils/parseDate";

const space = {
  shared: "Compartilhado",
  exclusive: "Exclusivo",
  "1_tendas": "1 Tenda",
  "2_tendas": "2 Tendas",
  autoral: "Marcas Autorais",
  alimentacao: "Praça de Alimentação",
};

// Usar estilo padronizado do Admin com responsividade

export default function ViewButton({
  id,
  updateEvents,
  subscription,
}: {
  id: number;
  updateEvents: Function;
  subscription: any;
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <ModalComponent
        open={open}
        handleClose={handleClose}
        title="Detalhes da Pré-inscrição"
        maxWidth={isMobile ? "90%" : 600}
        autoHeight
      >
        <Box>
          <Typography variant="body2" sx={{ color: "#24324D" }}>
            Pagamento confirmado pelo evento:{" "}
            {subscription.is_paid ? "Sim" : "Não"}
          </Typography>
          <Typography variant="body2" sx={{ color: "#24324D" }}>
            Valor a ser pago: {subscription.is_paid ? "Sim" : "Não"}
          </Typography>

          <Typography variant="subtitle1" sx={{ my: 2, fontWeight: 600 }}>
            Suas escolhas
          </Typography>

          <Typography>
            <strong style={{ color: "#24324D" }}>Data de início:</strong>{" "}
            {parseDateLocale(subscription.start_date)}
          </Typography>
          <Typography>
            <strong style={{ color: "#24324D" }}>Data de fim:</strong>{" "}
            {parseDateLocale(subscription.end_date)}
          </Typography>
          <Typography>
            <strong style={{ color: "#24324D" }}>Tipo de espaço:</strong>{" "}
            {space[subscription.space_type]}
          </Typography>
          <Typography>
            <strong style={{ color: "#24324D" }}>Mesa extra:</strong>{" "}
            {subscription.extra_table ? "Sim" : "Não"}
          </Typography>
          <Typography>
            <strong style={{ color: "#24324D" }}>Quantas mesas:</strong>{" "}
            {subscription.table_quantity || 0}
          </Typography>
          <Typography>
            <strong style={{ color: "#24324D" }}>Cadeira Extra:</strong>{" "}
            {subscription.extra_chair ? "Sim" : "Não"}
          </Typography>
          <Typography>
            <strong style={{ color: "#24324D" }}>Quantas cadeiras:</strong>{" "}
            {subscription.chair_quantity || 0}
          </Typography>
          <Typography>
            <strong style={{ color: "#24324D" }}>Itens:</strong>{" "}
            {subscription.items}
          </Typography>
          <Typography>
            <strong style={{ color: "#24324D" }}>Observação:</strong>{" "}
            {subscription.notes}
          </Typography>
          <Typography>
            <strong style={{ color: "#24324D" }}>Valor:</strong> R${" "}
            {subscription.amount},00
          </Typography>
        </Box>
        <Box
          sx={{
            p: 2,
            borderTop: "1px solid",
            borderColor: "divider",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            onClick={handleClose}
            sx={adminButtonPrimarySx}
            fullWidth={isMobile}
          >
            Fechar
          </Button>
        </Box>
      </ModalComponent>
      <IconButton title="Pressione 2 vezes para ver mais" onClick={handleOpen}>
        <VisibilityIcon />
      </IconButton>
    </>
  );
}
